module.exports = __webpack_public_path__ + "static/media/program-info-icon-active.c4da8b14.svg";